import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/integrityCheck';

const initialState = fromJS({
  integrityChecks: { data: [], state: null },
  users: { data: [], state: null },
  processList: { data: [], state: null },
  processTypes: { data: [], state: null },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 1000, 5000, 10000],
  },
});

const MineralImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_INTEGRITY_CHECKS[START]: {
      return state
        .setIn(['integrityChecks', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.FETCH_INTEGRITY_CHECKS[SUCCESS]: {
      return state
        .setIn(['integrityChecks', 'state'], fetchingState.LOADED)
        .setIn(
          ['integrityChecks', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['pagination', 'count'],
          fromJS(action.data ? action.data.recordCount : 0),
        );
    }
    case actions.FETCH_INTEGRITY_CHECKS[ERROR]: {
      return state.setIn(['integrityChecks', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_INTEGRITY_CHECK_USERS[START]: {
      return state.setIn(['users', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_INTEGRITY_CHECK_USERS[SUCCESS]: {
      return state
        .setIn(['users', 'state'], fetchingState.LOADED)
        .setIn(
          ['users', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_INTEGRITY_CHECK_USERS[ERROR]: {
      return state.setIn(['users', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PROCESS_LIST[START]: {
      return state.setIn(['processList', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROCESS_LIST[SUCCESS]: {
      return state
        .setIn(['processList', 'state'], fetchingState.LOADED)
        .setIn(
          ['processList', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PROCESS_LIST[ERROR]: {
      return state.setIn(['processList', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_PROCESS_TYPES[START]: {
      return state.setIn(['processTypes', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PROCESS_TYPES[SUCCESS]: {
      return state
        .setIn(['processTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['processTypes', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_PROCESS_TYPES[ERROR]: {
      return state.setIn(['processTypes', 'state'], fetchingState.ERROR);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }
    default: {
      return state;
    }
  }
};

export default MineralImportReducer;
